import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import ModalHeader from '@components/layout/Header/SP/ModalHeader';
import HeaderSpMenuContent from '@components/layout/Header/SP/MenuContent';
import ContactAndRequestButtons from '@components/layout/Header/SP/ContactAndRequestButtons';
import SocialMediaIcons from '@components/common/SocialMediaIcons';

interface MenuModalProps {
  open: boolean;
  handleClose: () => void;
}

export default function MenuModal({ open, handleClose }: MenuModalProps): React.JSX.Element {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      BackdropProps={{ style: { backgroundColor: '#191919' } }}
    >
      <Box className="pb-24 w-full max-w-screen-md md:space-y-8 mx-auto flex flex-col h-screen overflow-y-auto">
        <ModalHeader handleClose={handleClose} />
        <Box className="w-full px-4 max-md:mt-9">
          <HeaderSpMenuContent />
        </Box>
        <Box className="w-full max-md:mt-14">
          <ContactAndRequestButtons />
        </Box>
        <Box className="flex justify-center max-md:justify-start max-md:mx-4">
          <SocialMediaIcons color="white" />
        </Box>
      </Box>
    </Modal>
  );
}
